<template>
  <div class="mod-success">
    <a-layout class="layout" >
      <a-space direction="vertical" size="middle">
        <div :style="{textAlign: 'center', backgroundColor: '#fff'}">
          <h3>注销成功</h3>
          <p>您的账户 {{ phone | phoneEncryption }} 已注销成功，感谢您对{{ app.name }}的关注与支持</p>
          <div class="action" :style="{marginTop: '70vh'}">
            <a-button class="full-btn" size="large" type="primary" @click="onBack">确认</a-button>
          </div>
        </div>
      </a-space>
    </a-layout>
  </div>
</template>

<script>
import { isMobile } from '@/utils/util'

export default {
  props: {
    app: Object,
    phone: String
  },
  filters: {
    phoneEncryption (value) {
      let phone = '' + value
      phone = phone.replace(phone.substring(3, 7), '****')
      return phone
    }
  },
  methods: {
    onBack () {
      if (isMobile()) {
        window.__MICRO_ROOT__?.eventBus?.emit('Deregistration::Success', null)
      } else {
        window.location.replace('/')
      }
    }
  }
}
</script>
